import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';

import withModalView from 'components/ui/withModalView';
import withContentLoader from 'components/ui/withContentLoader';
import withAuthorizer from 'components/ui/withAuthorizer';

import DataGrid from 'react-data-grid';
import NoRecords from 'components/ui/DataGrid/NoRecords';

import { Resources } from 'helpers/ResourceHelper';
import NotFound from 'components/ui/NotFound';

import JobApi from 'api/job';

const JobWarningsPage = ({ data }) => {
  const { t } = useTranslation();

  if (!data) {
    return <NotFound />;
  }

  const columns = [{ key: 'text', name: t('keys.description') }];

  return (
    <>
      <div className="container">
        <div className="text-warning mb-2 d-flex align-items-center">
          <FiAlertTriangle size={16} />
          <div className="m-3">
            {data.warnings.length} {t('keys.warnings').toLowerCase()}
          </div>
        </div>
        <h3>{data.job.bot.name}</h3>

        <DataGrid
          cellNavigationMode={true}
          columns={columns}
          rows={data.warnings}
          className="data-grid rdg-light"
          rowName="row"
          rowHeight={60}
          emptyRowsRenderer={NoRecords}
        />
      </div>
    </>
  );
};

const fetchData = async ({ routeMatch }) => {
  const { params } = routeMatch;
  const job = await JobApi.get(params.jobId);
  const warnings = await JobApi.getWarnings(params.jobId);

  return { job, warnings };
};

const page = withContentLoader(JobWarningsPage, { name: 'job-warnings', fetchData });
export default withModalView(withAuthorizer(page, [Resources.BOT_MANAGER]));
